module.exports = __webpack_public_path__ + "img/chehaoduo.88541891.png";